var _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32656 8.16042L4.45589 5.14888C4.60225 4.75857 4.97537 4.5 5.39222 4.5H12.5062C12.9231 4.5 13.2962 4.75857 13.4425 5.14888L14.5719 8.16042C14.6561 8.38498 14.6992 8.62285 14.6992 8.86267V13.5V14.9004C14.6992 14.9554 14.6546 15 14.5996 15C14.5446 15 14.5 14.9554 14.5 14.9004V13.5H3.5V14.8496C3.5 14.9327 3.43267 15 3.34961 15C3.26655 15 3.19922 14.9327 3.19922 14.8496V13.5V8.86267C3.19922 8.62285 3.24235 8.38498 3.32656 8.16042Z",
    fill: "#DBE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6992 13.5V8.86267C14.6992 8.62285 14.6561 8.38498 14.5719 8.16042L13.4425 5.14888C13.2962 4.75857 12.9231 4.5 12.5062 4.5H5.39222C4.97537 4.5 4.60225 4.75857 4.45589 5.14888L3.32656 8.16042C3.24235 8.38498 3.19922 8.62284 3.19922 8.86267V13.5M14.6992 13.5V14.9004C14.6992 14.9554 14.6546 15 14.5996 15V15C14.5446 15 14.5 14.9554 14.5 14.9004V13.5M14.6992 13.5H14.5M3.19922 13.5V14.8496C3.19922 14.9327 3.26655 15 3.34961 15V15C3.43267 15 3.5 14.9327 3.5 14.8496V13.5M3.19922 13.5H3.5M3.5 13.5H14.5",
    stroke: "#4258BF",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5H14.5",
    stroke: "#4258BF",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.8,
    cy: 11.0998,
    r: 0.8,
    fill: "#4258BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8,
    cy: 11.0998,
    r: 0.8,
    fill: "#4258BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.e7c2aa6adccd1e09ea15b88569c1429e.svg";
export { ForwardRef as ReactComponent };